module.exports = __webpack_public_path__ + "img/solution_jz.85404db7.svg";